module.exports = __webpack_public_path__ + "static/media/ComingSoon.f2cb6ea5.svg";